


import { Component, Vue, Emit, Prop, Watch } from 'vue-property-decorator';
import { Zone } from '../../utils/api';
import { namespace } from 'vuex-class';

const appModule = namespace('app');

@Component({})
export default class ZoneNavigation extends Vue {
  @appModule.State private deviceMQ!: string;

  @Prop({ default: () => [] }) completedZoneIDs!: string[];
  @Prop({ default: () => [] }) zones!: Zone[];
  @Prop() activeZone!: Zone;

  @Emit()
  private changeZone(zoneID: string, el: HTMLElement) {
    this.updateIndicatorPosition(el);

    return zoneID;
  }

  @Emit()
  private showLayout(el: HTMLElement) {
    this.updateIndicatorPosition(el);

    return;
  }

  private mounted() {
    this.updateIndicatorPosition();
  }

  @Watch('deviceMQ')
  private breakpointChanged() {
    this.updateIndicatorPosition();
  }

  private isActive(zoneID: string) {
    return zoneID === this.activeZone?.ID;
  }

  private updateIndicatorPosition(el: HTMLElement | null = this.$el.querySelector('.-active')) {
    if (el) {
      (this.$el as HTMLElement).style.setProperty('--width', el.clientWidth.toString() + 'px');
      (this.$el as HTMLElement).style.setProperty('--left', el.offsetLeft.toString() + 'px');
    }
  }

  private isCompleted(zoneID: string) {
    return this.completedZoneIDs.find(completedZoneID => completedZoneID === zoneID);
  }
}
